import script from "./ChooseScoreForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChooseScoreForm.vue?vue&type=script&setup=true&lang=ts"

import "./ChooseScoreForm.vue?vue&type=style&index=0&id=a196190c&lang=scss&scoped=true"

import exportComponent from "/home/ni/IdeaProjects/pioneer/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a196190c"]])

export default __exports__